import { Col, Row } from 'antd';
import moment from 'moment';
import React from 'react';
import FormDate from '../../../../../../components/Form/FormDate/FormDate';
import FormDropdown from '../../../../../../components/Form/FormDropdown/FormDropdown';
import FromTextArea from '../../../../../../components/Form/FormTextArea/FromTextArea';
import styles from './about.module.scss';

const FirstCol = (props) => {
  const { data, setData } = props;
  return (
    <>
      <div className={styles.sub_title}>About me</div>
      <FromTextArea
        borderColor="#D3DEE8"
        placeholder="Enter Description"
        rows={16}
        value={data.about_me}
        setFormData={(value) => setData('about', { ...data, about_me: value })}
      />
    </>
  );
};

const SecondCol = (props) => {
  const { data, setData, top_talent_categories, role_levels, sg_jg_options } = props;
  return (
    <>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Top Talent Category</div>
        <FormDropdown
          borderColor="#D3DEE8"
          placeholder="Select Top Talent Category"
          value={data.top_talent_category}
          setFormData={(value) => setData('about', { ...data, top_talent_category: value })}
          options={top_talent_categories}
        />
      </div>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Role Level Equivalent</div>
        <FormDropdown
          borderColor="#D3DEE8"
          placeholder="Select Role Level Equivalent"
          value={data.role_level_equivalent}
          setFormData={(value) => setData('about', { ...data, role_level_equivalent: value })}
          options={role_levels}
        />
      </div>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Job Grade</div>
        <FormDropdown
          borderColor="#D3DEE8"
          placeholder="Select Job Grade"
          value={data.job_grade}
          setFormData={(value) => setData('about', { ...data, job_grade: value })}
          options={sg_jg_options}
          allowCustomValue
        />
      </div>
      <div>
        <div className={styles.sub_title}>Salary Grade</div>
        <FormDropdown
          borderColor="#D3DEE8"
          placeholder="Select Salary Grade"
          value={data.salary_grade}
          setFormData={(value) => setData('about', { ...data, salary_grade: value })}
          options={sg_jg_options}
          allowCustomValue
        />
      </div>
    </>
  );
};

const ThirdCol = (props) => {
  const { data, setData } = props;
  return (
    <>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Retirement Date</div>
        <FormDate
          borderColor="#D3DEE8"
          placeholder="Select Retirement Date"
          value={data.retirement_date}
          setFormData={(value) => setData('about', { ...data, retirement_date: moment(value).format() })}
          data-testid="retirement-date"
        />
      </div>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Contract End Date</div>
        <FormDate
          borderColor="#D3DEE8"
          placeholder="Select Contract End Date"
          value={data.contract_end_date}
          setFormData={(value) => setData('about', { ...data, contract_end_date: moment(value).format() })}
          data-testid="contract-end-date"
        />
      </div>
      <div className={styles.margin}>
        <div className={styles.sub_title}>Date in Position</div>
        <FormDate
          borderColor="#D3DEE8"
          placeholder="Select Date in Position"
          value={data.date_in_position}
          setFormData={(value) => setData('about', { ...data, date_in_position: moment(value).format() })}
          data-testid="date-in-position"
        />
      </div>
      <div>
        <div className={styles.sub_title}>Date in Salary Grade</div>
        <FormDate
          borderColor="#D3DEE8"
          placeholder="Select Date in Salary Grade"
          value={data.date_in_salary_grade}
          setFormData={(value) => setData('about', { ...data, date_in_salary_grade: moment(value).format() })}
          data-testid="date-in-salary-grade"
        />
      </div>
    </>
  );
};

const About = (props) => {
  const { data, setData } = props;
  return (
    <div className={styles.margin}>
      <Row justify="space-between">
        <Col style={{ width: '31%' }}>
          <FirstCol data={data} setData={setData} />
        </Col>
        <Col style={{ width: '31%' }}>
          <SecondCol data={data} setData={setData} {...props} />
        </Col>
        <Col style={{ width: '31%' }}>
          <ThirdCol data={data} setData={setData} />
        </Col>
      </Row>
    </div>
  );
};

export default About;
